/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id              = 'pageMain',
    Page            = require('stb-component-page'),
    app             = require('mag-app'),
    appConf         = require('../config'),
    page            = new Page({$node: document.getElementById(id)}),
    PanelSet        = require('mag-component-panel-set'),
    PanelExtended   = require('mag-component-panel'),
    LayoutList      = require('mag-component-layout-list'),
    ModalCheckList  = require('mag-component-modal-check-list'),
    ModalMessage    = require('mag-component-modal'),
    RadioList       = require('mag-component-radio-list'),
    dom             = require('spa-dom'),
    keys            = require('stb-keys'),
    tools           = require('../modules/tools'),
    Scroll          = require('stb-component-scrollbar'),
    Flicker         = require('spa-component-flicker'),
    ScrollArea      = require('mag-component-scroll-area'),
    fileSystem      = window.core.plugins.fs,
    downloadManager = window.core.plugins.downloadManager,
    downloadStates  = downloadManager.states,
    Footer          = require('mag-component-footer'),
    extensionByType = [
        {id: 1, title: 'video', data: fileSystem.mediaTypes.video},
        {id: 2, title: 'audio', data: fileSystem.mediaTypes.audio},
        {id: 3, title: 'playlist', data: fileSystem.mediaTypes.playlist},
        {id: 4, title: 'image', data: fileSystem.mediaTypes.image},
        {id: 5, title: 'files', data: fileSystem.mediaTypes.text.concat(fileSystem.mediaTypes.diskImage)}
    ],
    stateToClass    = {},
    stateToText     = {},
    $channelsCountWrapper, $channelsCount;


// define class name for each state
stateToClass[downloadStates.STOPPED] = 'theme-icon-pause';
stateToClass[downloadStates.WAITING] = 'theme-icon-clock theme-color-error';
stateToClass[downloadStates.RUNNING] = 'theme-icon-play';
stateToClass[downloadStates.FINISHED] = 'theme-icon-ok theme-color-success';
stateToClass[downloadStates.TEMPORARY_ERROR] = 'theme-icon-warning theme-color-warning';
stateToClass[downloadStates.PERMANENT_ERROR] = 'theme-icon-warning theme-color-warning';
// define text for each state
stateToText[downloadStates.STOPPED] = gettext('Paused');
stateToText[downloadStates.WAITING] = gettext('Waiting');
stateToText[downloadStates.RUNNING] = gettext('Running');
stateToText[downloadStates.FINISHED] = gettext('Completed');
stateToText[downloadStates.TEMPORARY_ERROR] = gettext('Error');
stateToText[downloadStates.PERMANENT_ERROR] = gettext('Error');

appConf.storages = (fileSystem.getMountPoints().concat(fileSystem.getHDDInfo()) || []);

$channelsCountWrapper = dom.tag(
    'div',
    {className: 'amountContainer'},
    $channelsCount = dom.tag('div', {className: 'amount'}, '0')
);

// Collect all downloads to one array
app.downloads = [];

page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();

page.footer = new Footer({visible: false, parent: page});

/**
 * Send intent to player with play action and currently focused task file path
 */
page.playFocusedFile = function () {
    var playable = fileSystem.mediaTypes.playable,
        // focused file data
        data     = page.middlePanel.list.$focusItem.data.items[1].download.data,
        ext      = (data.name.split('.').pop() || '').toLowerCase();

    // file loaded and have playable format
    if ( data.state === downloadStates.FINISHED && playable.indexOf(ext) !== -1 ) {
        window.core.intent({
            action: 'play', mime: 'content/video', data: {uri: data.path + '/' + data.name, title: data.name}
        }, function ( error ) {
            if ( error ) { window.core.notify({title: error.message, icon: 'alert', type: 'warning'}); }
        });
    }
};

/**
 * Remove currently focused item
 */
page.deleteFocusedTask = function () {
    downloadManager.remove(page.middlePanel.list.$focusItem.data.items[1].download, false, function ( error ) {
        if ( error ) {
            window.core.notify({title: error.message, icon: 'alert', type: 'warning'});
        }
        page.middlePanel.reset();
    });
};

/**
 * Set search, file and status filters to default value
 */
page.resetFilters = function () {
    var $catChilds = page.leftPanel.list.$body.children,
        arr, index;

    appConf.list.filterSearch = '';
    page.leftPanel.search.innerText = gettext('Search');
    $catChilds[1].children[0].children[0].classList.remove('active');

    // reset status filter and corresponding modal window
    if ( appConf.list.filterStatus !== null ) {
        arr = page.modalFilterStatus.children[0].data;
        for ( index = 0; index < arr.length; index++ ) {
            arr[index].state = !index;
        }
        page.modalFilterStatus.children[0].init({data: arr, focusIndex: 0});
        appConf.list.filterStatus = null;
        $catChilds[2].layout.$node.children[1].innerText = gettext('All categories');
        $catChilds[2].layout.$node.children[0].classList.remove('active');
    }

    // reset files filter and corresponding modal window
    if ( appConf.list.filterFiles.length ) {
        page.modalFilterFiles.clearChecked();
    }

    page.footer.hide();
    page.middlePanel.reset();
};


// modal message: all actions for middle list item
page.modalActions = new ModalMessage({
    visible: false,
    title: gettext('actions'),
    events: {
        show: function () {
            this.focus();
        },
        hide: function () {
            page.middlePanel.focus();
        }
    },
    children: [
        new LayoutList({
            cycle: true,
            data: [],
            propagate: true
        })
    ]
});
page.modalActions.fill = function ( data ) {
    // Timeout 1 of 2
    // Was added to fix visual artifacts during long and buggy dom rendering at mag322
    setTimeout(function () {
        var item     = data.$item.data.items[1].download,
            ext      = (item.data.name.split('.').pop() || '').toLowerCase(),
            playable = fileSystem.mediaTypes.playable,
            body     = [
                {
                    items: [
                        {className: 'theme-icon', value: ''},
                        {value: gettext('Details')}
                    ],
                    click: function () {
                        page.modalActions.hide();
                        page.panelSet.blur();
                        app.route(app.pages.info, page.middlePanel.list.$focusItem);
                    }
                }, {
                    items: [
                        {className: 'theme-icon theme-icon-rc-f1', value: ''},
                        {value: gettext('Delete task')}
                    ],
                    click: function () {
                        downloadManager.remove(item, false, function ( error ) {
                            if ( error ) {
                                window.core.notify({title: error.message, icon: 'alert', type: 'warning'});
                            } else {
                                page.modalActions.hide();
                                page.middlePanel.focus();
                                page.middlePanel.reset();
                            }
                        });
                    }
                }, {
                    items: [
                        {className: 'theme-icon', value: ''},
                        {value: gettext('Delete task and file')}
                    ],
                    click: function () {
                        downloadManager.remove(item, true, function ( error ) {
                            if ( error ) {
                                window.core.notify({title: error.message, icon: 'alert', type: 'warning'});
                            } else {
                                page.modalActions.hide();
                                page.middlePanel.focus();
                                page.middlePanel.reset();
                            }
                        });
                    }
                }
            ];

        // Task state: 0 – Stopped, 1 – WaitingQueue, 2 – Running,
        //             3 – Completed, 4 – TemporaryError, 5 - PermanentError
        // play playable file
        if ( item.data.state === downloadStates.FINISHED && playable.indexOf(ext) !== -1 ) {
            body.unshift({
                items: [
                    {className: 'theme-icon theme-icon-play', value: ''},
                    {value: gettext('Play file')}
                ],
                click: function () {
                    page.modalActions.hide();
                    page.panelSet.focus();
                    window.core.intent({
                        action: 'play',
                        mime: 'content/video',
                        data: {
                            uri: item.data.path + '/' + item.data.name,
                            title: item.data.name
                        }
                    }, function ( error ) {
                        if ( error ) { debug.log('error at play intent'); }
                    });
                }
            });
        }
        // Pause task
        if ( item.data.state === downloadStates.RUNNING ) {
            body.unshift({
                items: [
                    {className: 'theme-icon theme-icon-rc-play-pause', value: ''},
                    {value: gettext('Pause')}
                ],
                click: function () {
                    page.modalActions.hide();
                    page.panelSet.focus();
                    page.middlePanel.reset();
                    item.pause();
                }
            });
        }
        // Resume file loading
        if ( item.data.state === downloadStates.STOPPED ) {
            body.unshift({
                items: [
                    {className: 'theme-icon theme-icon-rc-play-pause', value: ''},
                    {value: gettext('Resume')}
                ],
                click: function () {
                    page.modalActions.hide();
                    page.panelSet.focus();
                    page.middlePanel.reset();
                    item.resume();
                }
            });
        }

        page.modalActions.children[0].init({data: body, size: body.length, focusIndex: 0});

        // Timeout 2 of 2
        // Was added to fix visual artifacts during long and buggy dom rendering at mag322
        setTimeout(function () {
            page.modalActions.show();
        }, 0);
    }, 0);
};
page.add(page.modalActions);


// modal message: reset all filters
page.modalReset = new ModalMessage({
    visible: false,
    title: gettext('actions'),
    events: {
        show: function () { this.focus(); },
        hide: function () { page.leftPanel.focus(); }
    },
    children: [
        new LayoutList({
            focusIndex: 0,
            cycle: true,
            size: 1,
            data: [
                {
                    items: [
                        {className: 'theme-icon theme-icon-rc-f1', value: ''},
                        {value: gettext('Reset filters')}
                    ],
                    click: function () {
                        page.resetFilters();
                        page.modalReset.hide();
                        page.panelSet.focus();
                    }
                }
            ],
            propagate: true
        })
    ]
});
page.add(page.modalReset);


// modal message: filter tasks by file type
page.modalFilterFiles = new ModalCheckList({
    visible: false,
    title: gettext('filter'),
    titleCounter: true,

    events: {
        show: function () { this.focus(); },
        hide: function () {
            page.middlePanel.reset();
            page.modalFilterFiles.hide();
            page.panelSet.focus();
        },

        'checked:change': function ( event ) {
            var $item  = page.leftPanel.list.$body.children[3].children[0],
                $icon  = $item.children[0],
                $title = $item.children[1],
                $count = $item.children[2],
                data   = event.checkedData,
                count;


            if ( data.length === 0 || data[0].unique ) {
                $icon.classList.remove('active');
                $title.innerText = gettext('All files');
                $count.style.visibility = 'hidden';
                appConf.list.filterFiles = [];
            } else {
                appConf.list.filterFiles = data.map(function ( item ) { return item.value; });
                $icon.classList.add('active');
                count = data.length - 2;

                if ( count >= 0 ) {
                    $title.innerText = data[0].title + ', ' + data[1].title;
                    if ( $title.scrollWidth > $title.clientWidth ) {
                        $title.innerText = data[0].title;
                        count++;
                    }

                    if ( count > 0 ) {
                        $count.style.visibility = 'inherit';
                        $count.firstChild.firstChild.innerText = '+' + count;
                    } else {
                        $count.style.visibility = 'hidden';
                    }

                } else {
                    $title.innerText = data[0].title;
                    $count.style.visibility = 'hidden';
                }
            }
        }
    },

    list: {
        cycle: true,
        focusIndex: 0,
        size: 5,
        data: [
            {state: true, title: gettext('All files'), value: 0, className: 'theme-header', unique: true},
            {state: false, title: gettext('Video'), value: 1},
            {state: false, title: gettext('Music'), value: 2},
            {state: false, title: gettext('Playlists'), value: 3},
            {state: false, title: gettext('Images'), value: 4},
            {state: false, title: gettext('Files'), value: 5}
        ]
    }
});
page.add(page.modalFilterFiles);


// modal message: filter by download status
// (0 – Stopped, 1 – WaitingQueue, 2 – Running, 3 – Completed, 4 – TemporaryError, 5 - PermanentError)
page.modalFilterStatus = new ModalMessage({
    visible: false,
    title: gettext('categories'),
    events: {
        show: function () { this.focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 5,
            propagate: true,
            data: [
                {state: true, title: gettext('All categories'), value: null},
                {state: false, title: gettext('Paused'), value: 0},
                {state: false, title: gettext('Completed'), value: 3},
                {state: false, title: gettext('In progress'), value: 2},
                {state: false, title: gettext('Waiting'), value: 1},
                {state: false, title: gettext('Error'), value: 5}
            ],
            events: {
                'click:item': function ( event ) {
                    var $item = page.leftPanel.list.$body.children[2].children[0];

                    if ( event.$item.data.value === null ) {
                        $item.children[0].classList.remove('active');
                    } else {
                        $item.children[0].classList.add('active');
                    }
                    $item.children[1].innerText = event.$item.data.title;
                    appConf.list.filterStatus = event.$item.data.value;
                    page.middlePanel.reset();
                    page.modalFilterStatus.hide();
                }
            }
        })
    ]
});
page.add(page.modalFilterStatus);


// modal message: sort
page.modalSort = new ModalMessage({
    visible: false,
    title: gettext('sort'),
    events: {
        show: function () { this.focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 3,
            data: [
                {state: true, title: gettext('By name'), value: appConf.constants.sort.BY_NAME},
                {state: false, title: gettext('By category'), value: appConf.constants.sort.BY_CATEGORY},
                {state: false, title: gettext('By size'), value: appConf.constants.sort.BY_SIZE}
            ],
            propagate: true,
            events: {
                'click:item': function ( event ) {
                    page.leftPanel.list.$focusItem.layout.$node.children[1].innerText = event.$item.data.title;
                    appConf.list.sort = event.$item.data.value;
                    page.middlePanel.reset();
                    page.modalSort.hide();
                }
            }
        })
    ]
});
page.add(page.modalSort);


// modal message: exit
page.modalExit = new ModalMessage({
    title: gettext('Exit'),
    className: 'modalExit',
    events: {
        show: function () { this.children[0].focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new LayoutList({
            size: 2,
            focusIndex: 0,
            data: [
                {
                    items: [{value: gettext('Yes')}],
                    click: function () {
                        page.modalExit.hide();
                        app.exit();
                    }
                }, {
                    items: [{value: gettext('No')}],
                    click: function () { page.modalExit.hide(); }
                }
            ],
            propagate: true
        })
    ]
});
page.add(page.modalExit);


// left panel (menu)
page.leftPanel = new PanelExtended({title: gettext('Menu'), children: [], className: 'leftPanel'});
page.leftPanel.add(page.leftPanel.list = new LayoutList({
    cycle: true,
    focusIndex: 0,
    size: 6,
    data: [
        {
            items: [
                {className: 'theme-icon theme-icon-plus', value: ''},
                {value: gettext('Create')}
            ],
            click: function () {
                page.panelSet.blur();
                app.route(app.pages.add);
            }
        }, {
            items: [
                {className: 'theme-icon theme-icon-search', value: ''},
                page.leftPanel.search = dom.tag('div', {className: 'searchText'}, gettext('Search'))
            ],
            click: function () {
                var inputText = page.leftPanel.search.innerText;

                window.core.intent({
                    action: 'keyboard',
                    data: {
                        type: 'text',
                        mode: 'qwerty',
                        title: gettext('SEARCH DOWNLOADS'),
                        description: gettext('DOWNLOADS'),
                        value: inputText === gettext('Search') ? '' : inputText
                    },
                    events: {
                        done: function ( event ) {
                            var $icon = page.leftPanel.list.$body.children[1].children[0].children[0];

                            if ( event.value ) {
                                $icon.classList.add('active');
                            } else {
                                $icon.classList.remove('active');
                            }
                            page.leftPanel.search.innerText = event.value || gettext('Search');
                            appConf.list.filterSearch = event.value;
                            page.middlePanel.reset();
                        }
                    }
                }, function ( error ) {
                    console.log(error);
                });
            }
        }, {
            items: [
                {className: 'theme-icon theme-icon-categories', value: ''},
                {value: gettext('All categories')}
            ],
            click: function () {
                page.panelSet.blur();
                page.modalFilterStatus.show();
            },
            className: 'theme-item-more'
        }, {
            items: [
                {className: 'theme-icon theme-icon-filter', value: ''},
                {value: gettext('All files')},
                dom.tag(
                    'div',
                    {className: 'theme-icon hidden'},
                    dom.tag(
                        'div',
                        {className: 'theme-counter'},
                        dom.tag('div')
                    )
                )
            ],
            click: function () {
                page.panelSet.blur();
                page.modalFilterFiles.show();
            },
            className: 'theme-item-more'
        }, {
            items: [
                {className: 'theme-icon theme-icon-sort-az', value: ''},
                {value: gettext('By name')}
            ],
            click: function () {
                page.panelSet.blur();
                page.modalSort.show();
            },
            className: 'theme-item-more'
        }, {
            items: [
                {className: 'theme-icon theme-icon-exit', value: ''},
                {value: gettext('Exit')}
            ],
            click: function () {
                page.panelSet.blur();
                page.modalExit.show();
            }
        }
    ],
    events: {
        'focus:item': function () {
            if ( appConf.list.filterSearch || appConf.list.filterStatus !== null || appConf.list.filterFiles.length ) {
                page.footer.init({
                    middle: [{code: keys.f1, title: gettext('Reset filters'), action: page.resetFilters}],
                    left: {
                        code: keys.menu,
                        action: function () {
                            page.panelSet.blur();
                            page.modalReset.show();
                        }
                    }
                });
                page.footer.show();
            } else {
                console.log('hide');
                page.footer.hide();
            }
        },
        focus: function () {
            if ( appConf.list.filterSearch || appConf.list.filterStatus !== null || appConf.list.filterFiles.length ) {
                page.footer.init({
                    middle: [{code: keys.f1, title: gettext('Reset filters'), action: page.resetFilters}],
                    left: {
                        code: keys.menu,
                        action: function () {
                            page.panelSet.blur();
                            page.modalReset.show();
                        }
                    }
                });
                page.footer.show();
            } else {
                page.footer.hide();
            }
        },
        blur: function () {
            page.footer.hide();
        }
    }
}));


// middle panel (downloads list)
page.middlePanel = new PanelExtended({
    title: [{value: gettext('Downloads'), className: 'name'}, $channelsCountWrapper],
    main: true,
    children: [],
    className: 'middlePanel'
});
// delay between buttons press and refreshing action menu and right panel
page.middlePanel.updateDelay = null;
page.middlePanel.scroll = new Scroll({});

page.middlePanel.add(page.middlePanel.list = new LayoutList({
    cycle: true,
    focusIndex: 0,
    size: 7,
    data: [],
    scroll: page.middlePanel.scroll,
    events: {
        'focus:item': function ( data ) {
            var body, ext;

            // abort previous update function call
            clearTimeout(page.middlePanel.updateDelay);
            page.middlePanel.updateDelay = setTimeout(function () {
                var focusItem = page.middlePanel.list.$focusItem;

                // update only if middle list is focused
                if ( page.activeComponent === page.middlePanel.list ) {
                    if ( data ) {
                        body = {
                            middle: [
                                {
                                    code: keys.f1,
                                    title: gettext('Delete task'),
                                    action: page.deleteFocusedTask
                                }
                            ],
                            left: {
                                code: keys.menu,
                                action: function () {
                                    // redefine menu to fix first item delayed add
                                    page.panelSet.blur();
                                    page.modalActions.fill({$item: page.middlePanel.list.$focusItem});
                                }
                            }
                        };

                        page.rightPanel.reset(data);

                        if ( focusItem && focusItem.data && focusItem.data.items[1].download.data.state === downloadStates.FINISHED ) {
                            ext = (focusItem.data.items[1].download.data.name.split('.').pop() || '').toLowerCase();
                            if ( fileSystem.mediaTypes.playable.indexOf(ext) !== -1 ) {
                                body.middle.push({
                                    code: keys.f2,
                                    title: gettext('Play file'),
                                    action: page.playFocusedFile
                                });
                            }
                        }
                        page.footer.init(body);
                        page.footer.show();
                    } else {
                        // bad item, hide footer
                        page.footer.hide();
                    }
                }
            }, window.core.environment.onFocusDebounceTimeout);
        },
        focus: function () {
            // show footer if list have at least one item
            var ext,
                body = {
                    middle: [{code: keys.f1, title: gettext('Delete task'), action: page.deleteFocusedTask}],
                    left: {
                        code: keys.menu,
                        action: function () {
                            page.panelSet.blur();
                            page.modalActions.fill({$item: page.middlePanel.list.$focusItem});
                        }
                    }
                };

            // if finished and playable, add 'Play file' footer button
            if ( page.middlePanel.list.$focusItem && page.middlePanel.list.$focusItem.data ) {
                ext = (page.middlePanel.list.$focusItem.data.items[1].download.data.name.split('.').pop() || '').toLowerCase();
                if ( fileSystem.mediaTypes.playable.indexOf(ext) !== -1 ) {
                    // playable file
                    if ( page.middlePanel.list.$focusItem.data.items[1].download.data.state === downloadStates.FINISHED ) {
                        body.middle.push({code: keys.f2, title: gettext('Play file'), action: page.playFocusedFile});
                    }
                }
                page.footer.init(body);
                page.footer.show();
            } else {
                // empty list so hide footer
                page.footer.hide();
            }
        },
        blur: function () {
            // hide footer
            page.footer.hide();
        }
    },
    noData: dom.tag(
        'div',
        {className: 'panelHint'},
        dom.tag(
            'div',
            {className: 'hint'},
            dom.tag('div', {className: 'hint', innerHTML: gettext('No downloads')})
        )
    )
}), page.middlePanel.scroll);

page.middlePanel.reset = function () {
    // prevent reset call spam
    clearTimeout(page.middlePanel.resetTimeOut);
    // Check downloads info change every "n" (depends on plugin config) seconds.
    page.middlePanel.resetTimeOut = setTimeout(function () {
        var body, index, index2, fileType, extension,
            downloads     = app.downloads.slice(),
            newData       = [],
            sortOrderHash = {},
            list          = page.middlePanel.list;

        // predefined additional sort order by task state for sort by category
        sortOrderHash[downloadStates.STOPPED] = 3;
        sortOrderHash[downloadStates.WAITING] = 2;
        sortOrderHash[downloadStates.RUNNING] = 1;
        sortOrderHash[downloadStates.FINISHED] = 4;
        sortOrderHash[downloadStates.TEMPORARY_ERROR] = 5;
        sortOrderHash[downloadStates.PERMANENT_ERROR] = 6;

        function itemClick () {
            if ( page.middlePanel.list.$focusItem ) {
                page.panelSet.blur();
                page.modalActions.fill({$item: page.middlePanel.list.$focusItem});
            }
        }

        for ( index = 0; index < downloads.length; index++ ) {
            // check if it correspond file filter
            // i need "continue" to make algorithm fast and simple
            /* eslint no-continue: 0 */
            if ( appConf.list.filterFiles.length && appConf.list.filterFiles[0] ) {
                extension = downloads[index].data.name.split('.').pop().toLowerCase();
                for ( index2 = 0; index2 < extensionByType.length; index2++ ) {
                    if ( extensionByType[index2].data.indexOf(extension) !== -1 ) {
                        fileType = extensionByType[index2].id;
                        break;
                    }
                }
                if ( appConf.list.filterFiles.indexOf(fileType) === -1 ) { continue; }
            }
            // check if it correspond to status filter
            if ( appConf.list.filterStatus !== null ) {
                if ( downloads[index].data.state !== appConf.list.filterStatus ) { continue; }
            }
            // check if it correspond to search filter
            if ( appConf.list.filterSearch.trim() &&
                downloads[index].data.name.indexOf(appConf.list.filterSearch) === -1 &&
                downloads[index].data.url.indexOf(appConf.list.filterSearch) === -1 ) {
                continue;
            }
            // add info about storage
            for ( index2 = 0; index2 < appConf.storages.length; index2++ ) {
                if ( downloads[index].data.path === appConf.storages[index2].mountPath ) {
                    downloads[index].data.storage = appConf.storages[index2];
                    break;
                }
            }

            newData.push({
                // (0 – Stopped, 1 – WaitingQueue, 2 – Running, 3 – Completed, 4 – TemporaryError, 5 - PermanentError)
                items: [
                    {
                        className: 'theme-icon ' + stateToClass[Number(downloads[index].data.state)],
                        value: ''
                    },
                    {
                        value: Math.floor(downloads[index].data.progress >= 0 ? downloads[index].data.progress : 0)
                        + '% ' + decodeURI(downloads[index].data.name),
                        download: downloads[index],
                        className: 'title'
                    }
                ],
                click: itemClick
            });
        }
        // sort it
        if ( newData.length ) {
            if ( !appConf.list.sort ) {
                // by name
                newData.sort(function ( first, next ) {
                    return first.items[1].download.data.name.toLowerCase().localeCompare(next.items[1].download.data.name.toLowerCase());
                });
            } else if ( appConf.list.sort === appConf.constants.sort.BY_CATEGORY ) {
                // by category
                newData.sort(function ( first, next ) {
                    return sortOrderHash[first.items[1].download.data.state] - sortOrderHash[next.items[1].download.data.state];
                });
            } else {
                // by size
                newData.sort(function ( first, next ) {
                    return next.items[1].download.data.size - first.items[1].download.data.size;
                });
            }
        }

        body = {data: newData};
        $channelsCount.innerText = newData.length;
        if ( newData.length ) {
            body.focusIndex = list.$focusItem && list.$focusItem.index < newData.length ? list.$focusItem.index : 0;
            page.middlePanel.scroll.init({realSize: newData.length, viewSize: 7});
            page.middlePanel.scroll.show();
        } else {
            page.rightPanel.reset();
            if ( page.activeComponent === page.middlePanel.list ) { page.footer.hide(); }
            page.middlePanel.scroll.hide();
        }
        list.init(body);
    }, 300);
};

// right panel (download information)
page.rightPanel = new PanelExtended({title: gettext('Details'), className: 'rightPanel'});
page.rightPanel.scroll = new Scroll({});
page.rightPanel.textArea = new ScrollArea({propagate: true, step: 5, scroll: page.rightPanel.scroll});
page.rightPanel.add(page.rightPanel.textArea, page.rightPanel.scroll);
page.rightPanel.reset = function ( data ) {
    var area = page.rightPanel.textArea,
        item;

    if ( !area.$url ) {
        area.$body.appendChild(dom.fragment(
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('URL:')),
            area.$url = dom.tag('div', {}),
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('Storage:')),
            area.$storage = dom.tag('div', {}),
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('Size:')),
            area.$size = dom.tag('div', {}),
            dom.tag('div', {className: 'title theme-subhead-color'}, gettext('State:')),
            area.$state = dom.tag('div', {})
        ));
    }
    if ( data && data.$curr && data.$curr.data ) {
        item = data.$curr.data.items[1].download.data;
        area.$url.innerText = decodeURIComponent(item.url);
        area.$storage.innerText = item.storage ? item.storage.label : gettext('Not connected');
        area.$size.innerText = tools.convert(item.size);
        area.$state.innerText = stateToText[Number(item.state)];
        page.rightPanel.textArea.show();
        page.rightPanel.textArea.init();
    } else {
        page.rightPanel.textArea.hide();
    }
};


fileSystem.onMount = function ( state ) {
    //debug.info('onMount: ' + state);
    appConf.storages = fileSystem.getMountPoints().concat(fileSystem.getHDDInfo());
    if ( app.pages.add.active ) {
        if ( app.pages.add.modalSelectDevice.visible ) {
            app.pages.add.modalSelectDevice.hide();
        }
        app.pages.add.panelSet.reset();
        app.pages.add.panelSet.focus();
    }
    if ( state ) {
        // restore old tasks from new storage device
        appConf.storages.forEach(function ( item ) {
            downloadManager.restore(item.mountPath, function ( error ) {
                if ( error ) { debug.log('error during records restore from storage ' + error); }
            });
        });
    } else if ( downloadManager.validate ) {
        // cleanup trash tasks left after storage removal
        downloadManager.validate();
    }
};

// panel set: main
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetMain'),
    focusIndex: 0,
    panels: [page.leftPanel, page.middlePanel, page.rightPanel]
});
page.add(page.panelSet);

// restore old tasks from all connected storage devices
appConf.storages.forEach(function ( item ) {
    downloadManager.restore(item.mountPath, function ( error ) {
        if ( error ) { debug.log('error during records restore from storage ' + error); }
    });
});

// download manager events - reset old, add new
downloadManager.events = {};
downloadManager.addListeners({
    add: function ( config ) {
        if (
            config.item.data.state === downloadStates.PERMANENT_ERROR
            || config.item.data.state === downloadStates.TEMPORARY_ERROR
        ) {
            window.core.notify({title: gettext('Download error'), icon: 'alert', type: 'warning'});
        }
        app.downloads.push(config.item);
        page.middlePanel.reset();
    },
    remove: function ( config ) {
        app.downloads.splice(app.downloads.indexOf(config.item), 1);
        page.middlePanel.reset();
    },
    progress: function () {
        page.middlePanel.reset();
    },
    state: function ( config ) {
        if (
            config.item.data.state === downloadStates.PERMANENT_ERROR
            || config.item.data.state === downloadStates.TEMPORARY_ERROR
        ) {
            window.core.notify({title: gettext('Download error'), icon: 'alert', type: 'warning'});
        }
        page.middlePanel.reset();
    }
});
downloadManager.reset();

// window.core.intent({action: 'download',data: {uri: 'http://10.110.22.65:4343/mags.mp4', title: 'video.mp4'}}, function () {console.log('callback intent');});
window.core.addListener('intent', function ( intent, callback ) {
    if ( intent.action === 'download' ) {
        app.intent = intent;
        app.route(app.pages.add);
        app.pages.add.reset();
        callback(false, {});
    }
});


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            page.panelSet.blur();
            window.core.call('stop');
            break;
    }
});

page.addListener('show', function () {
    page.panelSet.show();
    page.panelSet.focus();
});

window.core.addListeners({
    show: function () { page.clock.start(); },
    hide: function () { page.clock.stop(); },
    exit: function () {
        downloadManager.events = {};
        downloadManager.reset();
    }
});

app.route(page);
page.show();

// public
module.exports = page;
